import { SendBiFunction, IBiData } from './types';

export const createBIEvent = <Fields extends Record<string, string>>({
  src,
  evid,
  fields,
}: IBiData<Fields>) => ({
  evid,
  src,
  fields,
});

export const createBIEventFactory =
  (src: number) =>
  <Fields extends Record<string, string>>(evid: number, fields: Fields) =>
    createBIEvent<Fields>({ evid, src, fields });

// TODO: get type from here: https://github.com/wix-private/responsive-editor/blob/master/src/client/bi.ts#L155
type ResponsiveEditorBI = any;

type ResponsiveEditorWindow = typeof window & {
  responsiveEditorBI: ResponsiveEditorBI;
};

const hasResponsiveBI = (
  editorWindow: any,
): editorWindow is ResponsiveEditorWindow =>
  editorWindow.hasOwnProperty('responsiveEditorBI');

export const createComponentBI =
  (
    // TODO: Use real editorAPI types
    editorAPI: Record<string, any>,
    extraParams: Record<string, string> = {},
  ): SendBiFunction =>
  (event, eventParams) => {
    const params = {
      component_type: editorAPI.components?.getType(
        editorAPI.selection.getSelectedComponents()[0],
      ),
      ...eventParams,
      ...extraParams,
    };

    if (hasResponsiveBI(window)) {
      const logger = window.responsiveEditorBI.biLoggerFactory.logger();
      return logger.report({
        endpoint: 'editor-x',
        ...event,
        params,
      });
    }

    return editorAPI.selectedComponent.sendSelectedComponentBI(event, params);
  };
